import uploadFileToStorage from "./storageService"

export default uploadFileToStorage
